import { ApiKeyScope, PARTNER_SCOPES, PartnerScope } from "@/shared/api/settings"

/**
 * Три партнёрских read scope выдаются независимо друг от друга и по умолчанию
 * не выданы. Форма всегда стартует от фактических scopes ключа: ни один scope
 * не может быть добавлен молча — только явным переключением администратором.
 */
export interface ScopeFormValues {
    adminAuditRead: boolean
    iamAdminsRead: boolean
    partnerEventsRead: boolean
}

export interface ScopeField {
    name: keyof ScopeFormValues
    scope: PartnerScope
    label: string
}

export const SCOPE_FIELDS: ScopeField[] = [
    {
        name: "adminAuditRead",
        scope: "admin-audit:read",
        label: "Чтение журнала действий администраторов",
    },
    {
        name: "iamAdminsRead",
        scope: "iam-admins:read",
        label: "Чтение списка администраторов (IAM)",
    },
    {
        name: "partnerEventsRead",
        scope: "partner-events:read",
        label: "Чтение вызовов партнёрского API",
    },
]

export const emptyScopeFormValues = (): ScopeFormValues => ({
    adminAuditRead: false,
    iamAdminsRead: false,
    partnerEventsRead: false,
})

export const scopesToFormValues = (scopes: readonly ApiKeyScope[] | undefined): ScopeFormValues => {
    const held = new Set(scopes ?? [])

    return SCOPE_FIELDS.reduce<ScopeFormValues>(
        (values, field) => ({ ...values, [field.name]: held.has(field.scope) }),
        emptyScopeFormValues()
    )
}

const isKnownScope = (scope: ApiKeyScope): scope is PartnerScope =>
    (PARTNER_SCOPES as readonly string[]).indexOf(scope) !== -1

/**
 * Собирает набор разрешений для отправки. Известные три берутся из
 * переключателей в порядке контракта провайдера; любой неизвестный клиенту
 * scope, уже выданный ключу, переносится без изменений — иначе сохранение
 * формы молча сузило бы права, что симметрично запрету молча их расширять.
 */
export const formValuesToScopes = (
    values: ScopeFormValues,
    currentScopes: readonly ApiKeyScope[] = []
): ApiKeyScope[] => {
    const selected = SCOPE_FIELDS
        .filter((field) => values[field.name])
        .map((field) => field.scope)

    const known: ApiKeyScope[] = PARTNER_SCOPES.filter((scope) => selected.includes(scope))
    const preserved = currentScopes.filter((scope) => !isKnownScope(scope))

    return [...known, ...preserved]
}
